import type { World, WorldAnalyticsEvent } from "@iyk/music-domain"
import { Data } from "effect"
import React from "react"

export type WorldAnalyticsPayload =
  | WorldAnalyticsEvent.Payloads.FooterLinkClicked
  | WorldAnalyticsEvent.Payloads.WorldIdShared

export const WorldAnalyticsPayload = Data.taggedEnum<WorldAnalyticsPayload>()

interface WorldAnalyticsContext {
  track(worldId: World.Id, payload: WorldAnalyticsPayload): Promise<void>
}

const WorldAnalyticsContext = React.createContext<WorldAnalyticsContext | null>(null)

export const WorldAnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = React.useMemo(
    () => ({
      track: async (worldId: World.Id, payload: WorldAnalyticsPayload) => {
        await fetch(`${import.meta.env.BASE_URL}activity/track`, {
          method: "POST",
          body: JSON.stringify({ worldId, payload })
        })
      }
    }),
    []
  )

  return <WorldAnalyticsContext.Provider value={value}>{children}</WorldAnalyticsContext.Provider>
}

export const useWorldAnalytics = () => {
  const worldAnalytics = React.useContext(WorldAnalyticsContext)

  if (!worldAnalytics) {
    throw new Error("useWorldAnalytics must be used within a WorldAnalyticsProvider")
  }

  return worldAnalytics
}
